import React from "react";
import { useSelector } from "react-redux";
import { selectAdminUuid } from "../features/auth/authSlice";
import Login from "../features/auth/Login";
import { Navigate } from "react-router-dom";

export default function LoginPage() {
  // If already logged in, redirect to the home page
  if (useSelector(selectAdminUuid)) {
    return <Navigate replace to="/" />;
  }

  // Render the login form
  return <Login />;
}
